import { IPublicClientApplication } from "@azure/msal-browser";
import { StyledEngineProvider } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import {
	AuthenticatedTemplate,
	MsalProvider,
	UnauthenticatedTemplate,
} from "@azure/msal-react";

import AdministratorPanel from "./views/AdministratorPanel/AdministratorPanel";
import IdeaInformation from "./views/IdeaInformation/IdeaInformation";
import SuccessCases from "./views/SuccessCases/SuccessCases";
import MeetIdeas from "./views/MeetIdeas/MeetIdeas";
import IdeaForm from "./views/IdeaForm/IdeaForm";
import Kanban from "./views/Kanban/Kanban";
import Ideas from "./views/Ideas/Ideas";
import Login from "./views/Login/Login";
import Home from "./views/Home/Home";

function App({ pca }: { pca: IPublicClientApplication }) {
	return (
		<StyledEngineProvider injectFirst>
			<MsalProvider instance={pca}>
				<>
					<UnauthenticatedTemplate>
						<Routes>
							<Route
								path="/"
								element={<Login></Login>}
							></Route>
						</Routes>
					</UnauthenticatedTemplate>
					<AuthenticatedTemplate>
						<Routes>
							<Route
								path="/"
								Component={Home}
							/>

							<Route
								path="/comparte_idea"
								Component={IdeaForm}
							/>

							<Route
								path="/casos_exito"
								Component={SuccessCases}
							/>

							<Route
								path="/kanban"
								Component={Kanban}
							/>

							<Route
								path="/tus_ideas"
								Component={Ideas}
							/>

							<Route
								path="/conoce_ideas"
								Component={MeetIdeas}
							/>

							<Route
								path="/idea_informacion"
								Component={IdeaInformation}
							/>

							<Route
								path="/administrator"
								Component={AdministratorPanel}
							/>
						</Routes>
					</AuthenticatedTemplate>
				</>
			</MsalProvider>
		</StyledEngineProvider>
	);
}

export default App;
